import React from "react";
import "../styles.scss";
import { Text } from "@amzn/stencil-react-components/text";
import { Row } from "@amzn/stencil-react-components/layout";
import useArb from "../../../hooks/use-arb";
import { StatusContainer } from "./status-container";

export const ScreeningProcessHeader = () => {
  const bundle = useArb("HVHChecklistPantherResource");

  const formattedScreeningMsg = bundle.getMessage(
    "Checklist-AppointmentCard-Screen-Result"
  );
  const screeningwaittMsg = bundle.getMessage(
    "Checklist-AppointmentCard-Screen-Wait-Text"
  );

  return (
    <StatusContainer
      largeViewPortImage={require("./sandwatch.svg").default}
      smallViewPortImage={require("./sandwatch.svg").default}
    >
      <Text fontSize={"T400"} textAlign="center">
        {formattedScreeningMsg}
      </Text>

      <Row gridGap={"1rem"}>
        <Text fontSize={"T200"} textAlign="center">
          {screeningwaittMsg}
        </Text>
      </Row>
    </StatusContainer>
  );
};
